import { api } from './api';

export interface LaunchModeState {
  enabled: boolean;
  replicas: number;
  activatedAt?: string;
  activatedBy?: string;
}

export interface SetLaunchModePayload {
  enabled: boolean;
  replicas: number;
}

export async function getLaunchMode(): Promise<LaunchModeState> {
  const response = await api.get<LaunchModeState>('/admin/launch-mode');
  return response.data;
}

export async function setLaunchMode(payload: SetLaunchModePayload): Promise<LaunchModeState> {
  const response = await api.post<LaunchModeState>('/admin/launch-mode', payload);
  return response.data;
}
